module.exports = __webpack_public_path__ + "static/media/Galaxy1.7af81236.jpg";